export const dynamic_fields = [
  "{todaysDate}",

  "{clientEmail}", // d
  "{clientType}", // d
  "{clientName}",
  "{companyHouseNumber}",
  "{registeredAddress}",

  "{tradingName}",
  "{correspondenceAddress}",
  "{businessNature}",
  "{websiteLink}",

  "{clientStatus}", // d
  "{tradingStatus}", // d
  "{haveBookeeper}",
  "{bookeeperName}", // d
  "{bookeepingSystemName}", // d
  "{primaryPrefix}", // d
  "{primaryForename}",
  "{primarySurname}",
  "{primaryPreferredName}",
  "{primaryEmail}",
  "{primaryDateOfBirth}", // d
  "{primaryOccupation}",
  "{primaryContactNumberFirst}", // d
  "{primaryContactNumberSecond}", // d
  "{primaryAddressLine1}",
  "{primaryAddressLine2}",
  "{primaryCity}",
  "{primaryCountry}",
  "{primaryPostcode}",
  // "{primaryContactDescription}",
  "{haveSecondaryContact}",
  "{secondaryPrefix}", // d
  "{secondaryForename}",
  "{secondarySurname}",
  "{secondaryPreferredName}",
  "{secondaryEmail}",
  "{secondaryDateOfBirth}", // d
  "{secondaryOccupation}",
  "{secondaryContactNumberFirst}", // d
  "{secondaryContactNumberSecond}", // d
  "{secondaryAddressLine1}",
  "{secondaryAddressLine2}",
  "{secondaryCity}",
  "{secondaryCountry}",
  "{secondaryPostcode}",
  // "{secondaryContactDescription}",
  "{invoicingMethod}", // d
  "{paymentMethod}", // d
  "{totalAmount}", // d
  "{monthlyOverride}",

  "{UTRAppliedDate}",
  "{CACAppliedDate}",
  "{PAYEAppliedDate}",
  "{VATAppliedDate}",
  "{personalCodeAppliedDate}", // new
  "{UTRNumber}",
  "{UTRStatus}",
  "{letterLocationUTR}",
  "{CACStatus}",
  "{CACNumber}",
  "{letterLocationCAC}",
  "{insuranceNumber}",
  "{insuranceStatus}",
  "{letterLocationInsurance}",
  "{PAYEStatus}",
  "{PAYENumber}",
  "{letterLocationPAYE}",
  "{VATStatus}",
  "{VATNumber}",
  "{letterLocationVAT}",
  "{personalCode}", // new
  "{officerId}", // new

  "{isUTRAgentAuthorisationApplied}",
  "{UTRAgentAuthorisationAppliedDate}",
  "{UTRAgentAuthorisationStatus}",
  "{UTRAuthorisationCode}",
  "{UTRAgentAuthorisationLetterLocation}",
  "{UTRAgentAuthorisationNotAppliedReason}",
  // "{isCACAgentAuthorisationApplied}",
  // "{CACAgentAuthorisationAppliedDate}",
  // "{CACAgentAuthorisationStatus}",
  // "{CACAuthorisationCode}",
  // "{CACAgentAuthorisationLetterLocation}",
  // "{CACAgentAuthorisationNotAppliedReason}",
  "{isPAYEAgentAuthorisationApplied}",
  "{PAYEAgentAuthorisationAppliedDate}",
  "{PAYEAgentAuthorisationStatus}",
  "{PAYEAuthorisationCode}",
  "{PAYEAgentAuthorisationLetterLocation}",
  "{PAYEAgentAuthorisationNotAppliedReason}",
  "{isVATAgentAuthorisationApplied}",
  "{VATAgentAuthorisationAppliedDate}",
  "{VATAgentAuthorisationStatus}",
  "{VATAuthorisationCode}",
  "{VATAgentAuthorisationLetterLocation}",

  "{accountsAndTaxCurrentYearEndDate}", // d
  "{accountsAndTaxCurrentYearDueDate}", // d
  "{VATFirstPeriod}",
  "{VATFrequency}",
  "{VATCurrentPeriodEnd}",
  "{VATCurrentPeriodDueDate}",
  "{CISDate}",
  // "{CISFrequency}",
  "{CISDueDate}",
  // "{payrollFrequency}",
  // "{payrollFirstWeeklyDate}",
  // "{payrollSecondWeeklyDate}",
  // "{payrollFirstMonthlyDate}",
  // "{payrollSecondMonthlyDate}",
  // "{payrollFirstFourWeeklyDate}",
  // "{payrollSecondFourWeeklyDate}",
  // "{payrollFirstFortNightlyDate}",
  // "{payrollSecondFortNightlyDate}",
  "{bookkeepingFirstPeriodEnd}",
  "{bookkeepingFrequency}",
  "{bookkeepingCurrentPeriodEnd}",
  "{bookkeepingCurrentPeriodDueDate}",
  "{managementAccountFirstPeriodEnd}",
  "{managementAccountFrequency}",
  "{managementAccountCurrentPeriodEndDate}",
  "{managementAccountCurrentPeriodDueDate}",
  "{CScurrentYearDate}", // d
  "{CScurrentYearDueDate}", // d
  "{mostRecentKYCDate}", // d
  // "{KYCFrequency}",
  "{nextKYCDueDate}",
  "{clientUnderPracticeName}", // d
  "{clientCode}",
  "{clientManagerName}", // d
  "{productionManagerName}", // d
  "{assistantName}", // d
  "{administratorName}", // d
  // "{payrollManagerName}", // d
  // "{CISManagerName}", // d
  "{tradingName}", // d
  "{correspondenceAddress}", // d
  "{businessNature}", // d
  "{websiteLink}", // d
]

export const dynamic_fields_task = [
  "{periodEnd}",
  "{dueDate}",
  "{taskName}",
  "{taskStatus}",
]
